import { useState, useCallback, ChangeEvent, KeyboardEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { toast } from 'react-toastify';

import * as F from './FindPassword.style';
import useEnter from '@hooks/useEnter';
import { onlyNumber } from '@utils/common';
import { Mutation } from '@graphql/types';
import { FIND_ADMIN_PW } from '@graphql/mutations';
import { validateFindPw } from '@utils/validation';

import StyledInput from '@components/styled/StyledInput';
import StyledButton from '@components/styled/StyledButton';

const FindPassword = () => {
    const navigate = useNavigate();
    const onEnter = useEnter();
    const [loading, setLoading] = useState(false);
    const [inputs, setInputs] = useState({
        email: '',
        name: '',
        cellphone: ''
    });

    const [findAdminPw] =
        useMutation<Pick<Mutation, 'findAdminPw'>>(FIND_ADMIN_PW);

    const onChange = useCallback(
        (e: ChangeEvent<HTMLInputElement>) => {
            const { name, value } = e.target;
            if (name === 'cellphone') {
                return setInputs({
                    ...inputs,
                    [name]: onlyNumber(value)
                });
            }
            setInputs({
                ...inputs,
                [name]: value
            });
        },
        [inputs]
    );

    const handleSubmit = async () => {
        if (!validateFindPw(inputs)) return;

        const { email, name, cellphone } = inputs;

        setLoading(true);

        try {
            await findAdminPw({
                variables: {
                    account: email,
                    name,
                    cellphone
                },
                onCompleted: () => {
                    toast.success('임시 비밀번호가 이메일로 전송되었습니다.');
                    navigate('/');
                }
            });
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <F.Wrapper>
            <F.Title>비밀번호를 잊으셨나요?</F.Title>
            <F.SubTitle>등록된 이름과 휴대폰번호를 입력해주세요</F.SubTitle>
            <StyledInput
                value={inputs.email}
                name="email"
                onChange={onChange}
                placeholder="등록된 이메일을 입력해주세요"
                margin="0 0 8px"
                borderRadius={0}
                COLUMN
            />
            <StyledInput
                value={inputs.name}
                name="name"
                onChange={onChange}
                placeholder=" 이름을 입력해주세요"
                margin="0 0 8px"
                borderRadius={0}
                COLUMN
            />
            <StyledInput
                value={inputs.cellphone}
                name="cellphone"
                onChange={onChange}
                onKeyDown={(e: KeyboardEvent<HTMLInputElement>) =>
                    onEnter(e, handleSubmit)
                }
                placeholder="휴대폰번호 (-)없이 숫자만 입력 해주세요"
                maxLength={11}
                borderRadius={0}
                COLUMN
            />
            <StyledButton
                title="1회용 비밀번호 발급하기"
                margin="32px 0"
                width={343}
                fontSize={14}
                fontFamily="PretendardRegular"
                onClick={handleSubmit}
                borderRadius={0}
                loading={loading}
            />
        </F.Wrapper>
    );
};

export default FindPassword;
